import {
  DAYS_CREATE_FAIL,
  DAYS_CREATE_REQUEST,
  DAYS_CREATE_SUCCESS,
  DAYS_LIST_FAIL,
  DAYS_LIST_REQUEST,
  DAYS_LIST_SUCCESS,
  DAYS_LIST_FAIL_ID,
  DAYS_LIST_REQUEST_ID,
  DAYS_LIST_SUCCESS_ID,
  DAYS_UPDATE_FAIL,
  DAYS_UPDATE_REQUEST,
  DAYS_UPDATE_SUCCESS,
  DAYS_PATCH_FAIL,
  DAYS_PATCH_REQUEST,
  DAYS_PATCH_SUCCESS,
  DAYS_SINGLE_FAIL,
  DAYS_SINGLE_REQUEST,
  DAYS_SINGLE_SUCCESS,
  DAYS_DELETE_FAIL,
  DAYS_DELETE_REQUEST,
  DAYS_DELETE_SUCCESS,
} from "../constants/daysConstants";
import axios from "axios";
import createAuthConfig from "../utils/createAuthConfig";

// Define the API_URL using the environment variable
const API_URL = process.env.REACT_APP_API_URL;

export const listDays = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_LIST_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/days/`, config);

    dispatch({
      type: DAYS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: DAYS_LIST_FAIL,
      payload: message,
    });
  }
};

export const listDaysID = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_LIST_REQUEST_ID,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(
      `${API_URL}/api/days/my-account/journal`,
      config
    );

    dispatch({
      type: DAYS_LIST_SUCCESS_ID,
      payload: data,
    });
    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: DAYS_LIST_FAIL_ID,
      payload: message,
    });
  }
};

export const getDayByIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_SINGLE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.get(`${API_URL}/api/days/today/${id}`, config);

    dispatch({
      type: DAYS_SINGLE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: DAYS_SINGLE_FAIL,
      payload: message,
    });
  }
};

export const createDayAction = (today) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_CREATE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.post(
      `${API_URL}/api/days/today`,
      { today },
      config
    );

    await dispatch({
      type: DAYS_CREATE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: DAYS_CREATE_FAIL,
      payload: message,
    });

    throw new Error(message);
  }
};

// Patch-style update: only the fields the user actually changed travel on
// the wire, each carrying a client timestamp the server uses as a
// last-write-wins tiebreaker. The server returns the full reconciled state
// so the reducer can refresh non-dirty fields without a separate refetch.
export const patchDayAction =
  (id, { patches, clientFieldTimestamps, deviceId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: DAYS_PATCH_REQUEST });
      const config = createAuthConfig();
      const { data } = await axios.patch(
        `${API_URL}/api/days/today/${id}`,
        { patches, clientFieldTimestamps, deviceId },
        config,
      );
      dispatch({ type: DAYS_PATCH_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: DAYS_PATCH_FAIL, payload: message });
      throw new Error(message);
    }
  };

export const updateDayAction = (id, today) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_UPDATE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.put(
      `${API_URL}/api/days/today/${id}`,
      { today },
      config
    );

    dispatch({
      type: DAYS_UPDATE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: DAYS_UPDATE_FAIL,
      payload: message,
    });

    throw new Error(message);
  }
};

export const deleteDayAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DAYS_DELETE_REQUEST,
    });

    const config = createAuthConfig();

    // Use the dynamic API_URL
    const { data } = await axios.delete(
      `${API_URL}/api/days/today/${id}`,
      config
    );

    dispatch({
      type: DAYS_DELETE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: DAYS_DELETE_FAIL,
      payload: message,
    });

    throw new Error(message);
  }
};
